/**
 * 学习乐园 · 排排序题材包：罗马数字（paixu/pack-luoma.js）
 * ---------------------------------------------------------------------------
 * 每局从 I 到 XII（1~12）里随机抽 8 个按数值排回（m 选 n）。罗马数字
 * 本身没有「表」可背，考的是把记法翻回数值再比大小：减法记法（IV=4、
 * IX=9、XL=40）是最容易错的地方——note 把每个数的记法拆讲清楚，
 * 排一遍等于把「大左加、小左减」的规则过一遍。只收到 XII：钟面刻度
 * 与 super bowl 等日常高频段就在 1~12。
 * items 顺序即正确答案；同包 face 不得重复（排序题天然满足）。
 */
(function (global) {
  'use strict';
  var PACKS = global.STPX_PACKS = global.STPX_PACKS || {};

  PACKS.luoma = {
    id: 'luoma',
    name: '罗马数字',
    hint: '每局抽 8 个按数值从小到大排',
    cols: 4,
    draw: 8,
    winText: 'I II III IV V VI VII VIII IX X XI XII——大在左就相加、小在左就相减，钟面上那圈就都认得了。',
    items: [
      { face: 'I', note: '1，一个手指' },
      { face: 'II', note: '2，两个 I 相加' },
      { face: 'III', note: '3，三个 I 相加——同符连写最多三个' },
      { face: 'IV', note: '4 = 5−1：小的写在大的左边就相减（减法记法）' },
      { face: 'V', note: '5，一只手掌' },
      { face: 'VI', note: '6 = 5+1：小的在右边就相加' },
      { face: 'VII', note: '7 = 5+2' },
      { face: 'VIII', note: '8 = 5+3，同符连写的上限就在这' },
      { face: 'IX', note: '9 = 10−1：又是减法记法，别写成 VIIII' },
      { face: 'X', note: '10，两只手掌交叉' },
      { face: 'XI', note: '11 = 10+1' },
      { face: 'XII', note: '12 = 10+2，钟面正上方的刻度，1~12 收尾' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
